/**
 * DownloadPage.tsx — /#/download
 */
import { useNavigate } from 'react-router-dom'

const GOLD = '#c9a84c'
const NAVY = '#0a1628'
const PANEL = '#0f1a2e'
const VERSION = '3.6.0'
const ANDROID_VERSION = 'versionCode 28'

export default function DownloadPage() {
  const navigate = useNavigate()

  return (
    <div style={{ background: NAVY, color: '#e2e8f0', fontFamily: "'Segoe UI', system-ui, sans-serif", minHeight: '100vh' }}>
      <nav style={{ background: 'rgba(10,22,40,0.95)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(201,168,76,0.15)', display: 'flex', alignItems: 'center', padding: '0 32px', height: 60, position: 'sticky', top: 0, zIndex: 100 }}>
        <div onClick={() => navigate('/')} style={{ fontSize: 20, fontWeight: 800, color: GOLD, letterSpacing: 2, flex: 1, cursor: 'pointer' }}>CASTELLAN</div>
        <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
          <span onClick={() => navigate('/find-agency')} style={{ color: '#94a3b8', cursor: 'pointer', fontSize: 14 }}>Sign in</span>
          <button onClick={() => navigate('/signup')} style={{ padding: '8px 20px', borderRadius: 8, background: GOLD, color: NAVY, fontWeight: 700, fontSize: 14, cursor: 'pointer', border: 'none' }}>Get started</button>
        </div>
      </nav>

      <div style={{ maxWidth: 800, margin: '0 auto', padding: '64px 24px' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <div style={{ display: 'inline-block', background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: 20, padding: '6px 16px', fontSize: 12, fontWeight: 700, color: GOLD, letterSpacing: '.1em', textTransform: 'uppercase' as const, marginBottom: 20 }}>Downloads</div>
          <h1 style={{ fontSize: 48, fontWeight: 800, color: '#f1f5f9', marginBottom: 12 }}>Get Castellan</h1>
          <p style={{ color: '#64748b', fontSize: 16 }}>Available on Android and Windows. iOS coming soon.</p>
          <p style={{ color: '#334155', fontSize: 13, marginTop: 8 }}>Current version: {VERSION}</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20, marginBottom: 48 }}>

          {/* Android */}
          <div style={{ background: PANEL, border: '1px solid rgba(201,168,76,0.15)', borderRadius: 16, padding: '28px 24px' }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>🤖</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#f1f5f9', marginBottom: 6 }}>Android</div>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 20, lineHeight: 1.6 }}>
              Available on Google Play. Install on any Android device running Android 8.0 or higher.
            </div>
            <div style={{ fontSize: 12, color: '#334155', marginBottom: 16 }}>Version {VERSION} · {ANDROID_VERSION}</div>
            <a
              href="https://play.google.com/store/apps/details?id=com.castellan.security"
              target="_blank" rel="noopener noreferrer"
              style={{ display: 'block', padding: '12px 0', background: GOLD, color: NAVY, borderRadius: 8, fontWeight: 700, fontSize: 14, textAlign: 'center' as const, textDecoration: 'none' }}
            >
              Get on Google Play →
            </a>
            <div style={{ marginTop: 12, fontSize: 12, color: '#334155', textAlign: 'center' as const }}>
              Or search <strong style={{ color: '#64748b' }}>Castellan Security</strong> on the Play Store
            </div>
          </div>

          {/* Windows */}
          <div style={{ background: PANEL, border: '1px solid rgba(201,168,76,0.15)', borderRadius: 16, padding: '28px 24px' }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>🖥️</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#f1f5f9', marginBottom: 6 }}>Windows</div>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 20, lineHeight: 1.6 }}>
              Desktop app for Windows 10/11. Includes standalone dashboard window with Ctrl+Shift+D shortcut.
            </div>
            <div style={{ fontSize: 12, color: '#334155', marginBottom: 16 }}>Version {VERSION} · NSIS installer · 64-bit</div>
            <a
              href={`https://github.com/aikhuoria26/castellan-security/releases/download/v${VERSION}/Castellan.Security.Setup.${VERSION}.exe`}
              style={{ display: 'block', padding: '12px 0', background: 'rgba(201,168,76,0.15)', color: GOLD, borderRadius: 8, fontWeight: 700, fontSize: 14, textAlign: 'center' as const, textDecoration: 'none' }}
            >
              Download for Windows →
            </a>
            <div style={{ marginTop: 12, fontSize: 12, color: '#334155', textAlign: 'center' as const }}>
              Run the installer and follow the setup wizard
            </div>
          </div>

          {/* iOS */}
          <div style={{ background: PANEL, border: '1px solid rgba(255,255,255,0.05)', borderRadius: 16, padding: '28px 24px', opacity: 0.6 }}>
            <div style={{ fontSize: 40, marginBottom: 16 }}>🍎</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#64748b', marginBottom: 6 }}>iOS</div>
            <div style={{ fontSize: 13, color: '#475569', marginBottom: 20, lineHeight: 1.6 }}>
              iPhone and iPad app is currently in development. Sign up for early access notification.
            </div>
            <button disabled style={{ width: '100%', padding: '12px 0', background: '#1e293b', color: '#475569', borderRadius: 8, fontWeight: 700, fontSize: 14, border: 'none', cursor: 'not-allowed' }}>
              Coming soon
            </button>
          </div>
        </div>

        {/* Web app note */}
        <div style={{ background: PANEL, border: '1px solid rgba(201,168,76,0.1)', borderRadius: 12, padding: '20px 24px', marginBottom: 48, display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{ fontSize: 28 }}>🌐</div>
          <div>
            <div style={{ fontWeight: 700, color: '#f1f5f9', marginBottom: 4 }}>No download required</div>
            <div style={{ fontSize: 14, color: '#64748b' }}>
              Castellan also runs fully in your browser. Just go to your organization's URL — e.g. <span style={{ color: GOLD }}>yourorg.castellan-security.com</span>. Nothing to install.
            </div>
          </div>
        </div>

        {/* System requirements */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 32 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, color: '#f1f5f9', marginBottom: 20 }}>System requirements</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {[
              ['Android', 'Android 8.0 (Oreo) or higher · 50 MB storage · Internet connection'],
              ['Windows', 'Windows 10 or 11 · 64-bit · 100 MB storage · Internet connection'],
              ['Browser', 'Chrome 90+, Firefox 88+, Edge 90+, Safari 14+'],
              ['Network', 'HTTPS internet connection required for cloud sync'],
            ].map(([platform, req]) => (
              <div key={platform} style={{ padding: '14px 16px', background: 'rgba(255,255,255,0.02)', borderRadius: 8, border: '1px solid rgba(255,255,255,0.05)' }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: GOLD, textTransform: 'uppercase' as const, letterSpacing: '.06em', marginBottom: 6 }}>{platform}</div>
                <div style={{ fontSize: 13, color: '#64748b', lineHeight: 1.5 }}>{req}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <footer style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: '28px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' as const, gap: 16 }}>
        <div style={{ fontSize: 16, fontWeight: 800, color: GOLD, letterSpacing: 2 }}>CASTELLAN</div>
        <div style={{ display: 'flex', gap: 24 }}>
          {[['Docs', '/docs'], ['Pricing', '/pricing'], ['Privacy', '/privacy'], ['Terms', '/terms']].map(([l, h]) => (
            <span key={l} onClick={() => navigate(h)} style={{ color: '#475569', cursor: 'pointer', fontSize: 13 }}>{l}</span>
          ))}
        </div>
        <div style={{ color: '#334155', fontSize: 12 }}>© 2026 Castellan Security</div>
      </footer>
    </div>
  )
}
